export const getSuppliersSuccess = (suppliers) => {
    return {
        type: "GET_SUPPLIERS_SUCCESS",
        payload: suppliers
    }
};
